// Central design tokens for styled-components ThemeProvider.
// Access in any styled block via ${({ theme }) => theme.colors.brand}.
export const theme = {
  colors: {
    brand: '#082189',
    brandDark: '#0f172a',
    brandGradientTo: '#1a3aaa',
    accentBlue: '#1e3a8a',
    text: '#111827',
    textMuted: '#6b7280',
    textFaint: '#9ca3af',
    border: '#e5e7eb',
    borderLight: '#f1f5f9',
    bg: '#f3f4f6',
    bgSoft: '#f9fafb',
    white: '#ffffff',
    success: '#16a34a',
    danger: '#dc2626',
    warning: '#f59e0b',
    star: '#f59e0b',
  },
  radii: { sm: '8px', md: '10px', lg: '14px', xl: '16px', xxl: '20px', pill: '40px' },
  shadow: {
    sm: '0 1px 4px rgba(0,0,0,0.04)',
    md: '0 4px 16px rgba(0,0,0,0.08)',
    lg: '0 20px 40px rgba(0,0,0,0.08)',
    brand: '0 4px 16px rgba(8,33,137,0.3)',
  },
  breakpoints: { sm: '480px', md: '768px', lg: '991px', xl: '1200px' },
};

// Convenience: media query helpers, e.g. ${({theme})=>theme.media.md}{...}
theme.media = {
  sm: `@media (max-width: ${theme.breakpoints.sm})`,
  md: `@media (max-width: ${theme.breakpoints.md})`,
  lg: `@media (max-width: ${theme.breakpoints.lg})`,
  xl: `@media (max-width: ${theme.breakpoints.xl})`,
};

export default theme;
